var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.429,
    height: 25.98,
    viewBox: "0 0 37.429 25.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31890",
    x: 0,
    y: 0,
    width: 37.429,
    height: 25.98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_Flag",
    "data-name": "No Flag",
    transform: "translate(1.499 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31890)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31890-2",
    "data-name": "Rectangle 31890",
    width: 34.429,
    height: 22.98,
    transform: "translate(1.5 0.5)",
    fill: "#fa2b2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40597",
    "data-name": "Path 40597",
    d: "M6.679,0V10.185h19.67V8.765H8.285V0Z",
    transform: "translate(8.081 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40598",
    "data-name": "Path 40598",
    d: "M6.679,5.638V15.823H8.285V7.061H26.349V5.638Z",
    transform: "translate(8.081 7.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40599",
    "data-name": "Path 40599",
    d: "M0,5.638V7.061H10.45v8.763h1.622V5.638Z",
    transform: "translate(0.001 7.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40600",
    "data-name": "Path 40600",
    d: "M10.45,0V8.765H0v1.42H12.072V0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40601",
    "data-name": "Path 40601",
    d: "M12.072,0V10.106H0v2.768H12.072V22.98h2.687V12.874h19.67V10.106H14.759V0Z",
    transform: "translate(0.001 0.001)",
    fill: "#00148d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFlag);
export default __webpack_public_path__ + "static/media/No Flag.bf8c2ee53dff58e19856c7a19fbfae31.svg";
export { ForwardRef as ReactComponent };